module.exports = __webpack_public_path__ + "media/images/social-share-button/facebook-62fd71be3dad9e15bd6c76ff15213f91.svg";